module.exports = __webpack_public_path__ + "media/images/baignoire pour bébés-874e12d095828ad4f43f1d7510a3c146.svg";